import React from 'react';
import PropTypes from 'prop-types';
import { Route as RouteOriginal, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const Route = ({
  authorizedOnly, allowedRoles, isAuthorized, history, userRoles, ...props
}) => {
  if (authorizedOnly && !isAuthorized) {
    history.replace('/');
    return null;
  }

  if (allowedRoles && !userRoles.some(r => allowedRoles.includes(r))) {
    history.replace('/');
    return null;
  }

  return <RouteOriginal {...props} />;
};

Route.propTypes = {
  authorizedOnly: PropTypes.bool,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  isAuthorized: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string),
};

Route.defaultProps = {
  authorizedOnly: false,
  allowedRoles: undefined,
  userRoles: [],
};

const mapStateToProps = state => ({
  isAuthorized: !!state.auth.token,
  userRoles: state.auth.roles,
});

export default withRouter(
  connect(mapStateToProps)(Route),
);
